module.exports = __webpack_public_path__ + "static/img/JCI_maintain.c70ef39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/JCI_maintain.png
// module id = fAqS
// module chunks = 1